import { makeSx } from '@saas/lib/shared-utils'
import { defaultPalette } from '../../../theme/idsTheme'

export const sxs = makeSx({
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2.1rem',
    },
    logo: {
        width: '11rem',
        height: 'auto',
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: 1.3,
        color: defaultPalette.typography.main,
    },
    icon: {
        fontSize: '1.75rem',
    },
    message: {
        textWrap: 'balance',
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5,
        padding: '0 1rem',
    },
    note: {
        textWrap: 'balance',
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5,
        color: defaultPalette.typography.main,
    },
})
